module.exports = __webpack_public_path__ + "static/media/logo-사고링크@3x.70b43723.png";